export const brand = "21吃瓜";

export const navLinks = [
  { id: "hot", label: "今日热议", icon: "ri-fire-line" },
  { id: "forum", label: "论坛帖子", icon: "ri-article-line" },
  { id: "comments", label: "评论区", icon: "ri-chat-3-line" },
  { id: "topics", label: "话题热议", icon: "ri-chat-history-line" },
  { id: "tags", label: "热门标签", icon: "ri-price-tag-3-line" },
  { id: "tools", label: "吃瓜工具", icon: "ri-apps-2-line" },
];

export const channels = [
  {
    icon: "ri-fire-line",
    title: "今日热议",
    desc: "全网话题实时升温，热搜榜、翻车现场、反转后续一网打尽",
    stat: "每日 300+ 条热议",
    accent: true,
  },
  {
    icon: "ri-chat-3-line",
    title: "评论区神评",
    desc: "段子手、课代表、理中客全在评论区，热评精华每日更新",
    stat: "累计 40w+ 热评",
    accent: false,
  },
  {
    icon: "ri-article-line",
    title: "论坛帖子",
    desc: "分区热帖直连，帖子互助补档，理性讨论与吃瓜细节两不误",
    stat: "28 个话题分区",
    accent: false,
  },
  {
    icon: "ri-download-2-line",
    title: "客户端与插件",
    desc: "网页版、App、桌面小组件、消息订阅插件一键直达下载",
    stat: "多端同步直达",
    accent: false,
  },
];

export const hotRank = [
  {
    id: 1,
    title: "某综艺直播事故时间线，网友逐帧复盘争议画面",
    summary: "从开场到中断全过程梳理，评论区已吵成两派，课代表正在补档细节图。",
    tag: "直播现场",
    heat: "128.6w",
  },
  {
    id: 2,
    title: "品牌道歉声明被扒出旧账，网友：这波回应不太聪明",
    summary: "声明发出不到一小时，过往争议截图相继被翻出，吃瓜群众表示先蹲后续。",
    tag: "品牌舆情",
    heat: "96.4w",
  },
  {
    id: 3,
    title: "同框照引热议，这对是不是真有点东西？",
    summary: "一张后台合影让超话瞬间炸锅，显微镜网友开始比对细节穿搭与表情。",
    tag: "CP 话题",
    heat: "73.9w",
  },
  {
    id: 4,
    title: "素人自曝聊天记录冲上热搜，网友态度两极分化",
    summary: "完整记录被公开后，理性分析派与情绪派争执不下，楼已经盖到两千层。",
    tag: "网友投稿",
    heat: "58.2w",
  },
  {
    id: 5,
    title: "裁员传闻再起，公司回应模棱两可引猜测",
    summary: "内部截图流出真假难辨，评论区出现多位自称知情人士，真实性待考。",
    tag: "职场热议",
    heat: "41.7w",
  },
  {
    id: 6,
    title: "被夸还是被嘲？某新剧人设再度引发审美大讨论",
    summary: "同一条台词两种解读，有人直呼真实，有人觉得矫情，热度持续走高。",
    tag: "影视讨论",
    heat: "33.5w",
  },
];

export const headFeature = {
  tag: "本期头版 · 超万人围观",
  title: "那晚的直播名场面，我们整理出了完整版时间线",
  summary:
    "开局一句口误，结尾一个反转。本文把当晚从开场到收尾的每一个关键节点都按分钟拆开，配合评论区的实时反应，带你一次看明白整件事的前因后果，也把讨论留给你。",
  views: "1.2w 人正在围观",
  img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20flat%20illustration%20of%20a%20live%20streaming%20show%20stage%20seen%20from%20the%20audience%2C%20bright%20spotlight%20over%20a%20round%20talk%20stage%20with%20silhouetted%20people%20talking%2C%20warm%20coral%20orange%20and%20cream%20ivory%20palette%20with%20soft%20peach%20gradients%2C%20clean%20minimal%20matte%20composition%2C%20no%20text%2C%20cozy%20lively%20discussion%20atmosphere&width=1280&height=720&seq=feature-2026-live&orientation=landscape",
};

export const forumPosts = [
  {
    title: "热搜第一的瓜，我整理了完整时间线（已补档）",
    summary: "从首发帖到三次反转，帖子已更新到最新进展，欢迎在楼里继续补充线索。",
    tag: "热点复盘",
    replies: "2.1k 回复",
    hot: true,
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20flat%20illustration%20of%20a%20large%20glowing%20community%20bulletin%20board%20pinned%20with%20layered%20colorful%20threads%20and%20speech%20bubbles%2C%20small%20modern%20people%20silhouettes%20standing%20and%20watching%20on%20phones%2C%20warm%20coral%20and%20cream%20ivory%20palette%2C%20clean%20minimal%20matte%20composition%2C%20no%20text%2C%20warm%20cozy%20community%20feeling&width=720&height=540&seq=forum-card-01&orientation=landscape",
  },
  {
    title: "直播间的名场面逐帧讲解，槽点全在这",
    summary: "一眼看漏的细节全给你圈出来，评论区段子手已就位，欢迎对号入座。",
    tag: "直播现场",
    replies: "1.5k 回复",
    hot: false,
    img: "https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20a%20modern%20smartphone%20with%20stacked%20notification%20popups%20and%20thumbs%20up%20reaction%20icons%20floating%20around%2C%20warm%20coral%20orange%20and%20cream%20ivory%20palette%20with%20soft%20peach%20tone%2C%20clean%20minimal%20matte%20editorial%20style%2C%20no%20text%2C%20fresh%20buzzing%20mobile%20feed%20mood&width=720&height=540&seq=forum-card-02&orientation=landscape",
  },
  {
    title: "求科普：这件事的来龙去脉到底怎么回事？",
    summary: "晚入场的网友别慌，一楼有热评版主整理的入门时间轴，看帖先从这开始。",
    tag: "新手入坑",
    replies: "986 回复",
    hot: false,
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20flat%20illustration%20of%20two%20people%20silhouettes%20chatting%20at%20a%20round%20table%20with%20floating%20speech%20bubbles%20and%20a%20timeline%20ribbon%2C%20warm%20coral%20orange%20and%20cream%20ivory%20palette%2C%20clean%20minimal%20matte%20composition%2C%20no%20text%2C%20friendly%20discussion%20and%20explanation%20mood&width=720&height=540&seq=forum-card-03&orientation=landscape",
  },
  {
    title: "当事人现身说法？先别急着站队",
    summary: "单方视角的帖子也很多，这里把不同说法的帖子集中对比，理性吃瓜第一课。",
    tag: "理性讨论",
    replies: "743 回复",
    hot: false,
    img: "https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20a%20balanced%20scale%20with%20two%20speech%20bubble%20masses%20on%20either%20side%2C%20warm%20coral%20and%20cream%20ivory%20palette%2C%20clean%20minimal%20matte%20editorial%20style%2C%20no%20text%2C%20calm%20fair%20comparison%20and%20critical%20thinking%20mood&width=720&height=540&seq=forum-card-04&orientation=landscape",
  },
  {
    title: "已删帖补档：那张截图里其实藏了三个细节",
    summary: "原帖消失不要慌，补档楼已备好，高清大图与时间戳对照都在正文里。",
    tag: "补档专区",
    replies: "1.2k 回复",
    hot: false,
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20flat%20illustration%20of%20a%20glowing%20bulletin%20board%20with%20a%20pin%20and%20highlighted%20paper%20card%20with%20magnifying%20glass%20icon%2C%20crowd%20of%20small%20people%20silhouettes%20gathered%20watching%2C%20warm%20coral%20orange%20and%20cream%20ivory%20palette%2C%20clean%20minimal%20matte%20composition%2C%20no%20text%2C%20curious%20detective%20community%20mood&width=720&height=540&seq=forum-card-05&orientation=landscape",
  },
  {
    title: "理性讨论：我们该怎么看待这波反转？",
    summary: "同一件事前后两套说法，别急着下结论，把不同帖子放在一起再聊聊。",
    tag: "观点交锋",
    replies: "2.8k 回复",
    hot: true,
    img: "https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20a%20group%20of%20people%20silhouettes%20in%20a%20circle%20debating%20around%20a%20glowing%20hot%20topic%20sign%20with%20diverging%20speech%20bubbles%20going%20up%2C%20warm%20coral%20orange%20and%20cream%20ivory%20palette%2C%20clean%20minimal%20matte%20editorial%20style%2C%20no%20text%2C%20lively%20respectful%20debate%20mood&width=720&height=540&seq=forum-card-06&orientation=landscape",
  },
];

export const scenes = [
  {
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20flat%20illustration%20of%20an%20evening%20city%20street%20with%20a%20glowing%20digital%20billboard%20flashing%20rumors%20and%20updates%2C%20a%20few%20people%20silhouettes%20looking%20up%20at%20the%20screen%2C%20warm%20amber%20coral%20and%20deep%20cream%20palette%20at%20dusk%2C%20clean%20minimal%20matte%20composition%2C%20no%20text%2C%20dramatic%20curious%20night%20mood&width=760&height=560&seq=scene-01&orientation=portrait",
    tag: "现场故事",
    title: "一张夜拍背后的来龙去脉",
    summary:
      "画面里那个亮着的屏幕，就是当晚所有人讨论的源头。本文用图文把现场、当事人说法与网友反应摊开来讲，尽量不预设立场，把判断留给你。",
    read: "读完需 4 分钟",
    upvotes: "点赞 2.6w",
  },
  {
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20flat%20illustration%20of%20a%20modern%20person%20holding%20a%20smartphone%20with%20glowing%20notification%20popups%20and%20reaction%20emoji%20icons%20flying%20off%20the%20screen%2C%20warm%20coral%20orange%20and%20cream%20ivory%20palette%20with%20soft%20peach%20shade%2C%20clean%20minimal%20matte%20composition%2C%20no%20text%2C%20viral%20mobile%20gossip%20update%20mood&width=760&height=560&seq=scene-02&orientation=portrait",
    tag: "图说热点",
    title: "从一张截图到三千层楼",
    summary:
      "截图是最快的传播，也最容易失真。我们顺着那张图往前翻、往后找，把出处、对比与网友补的后续都串起来，帮你把瓜吃完整。",
    read: "读完需 3 分钟",
    upvotes: "点赞 1.9w",
  },
];

export const comments = [
  {
    name: "晚睡十级选手",
    source: "评 · 直播名场面复盘",
    text: "看完完整时间线才发现前面都在瞎猜，课代表这个整理我给满分，转发给同款熬夜的朋友了。",
    likes: "点赞 4.8k",
    hot: true,
  },
  {
    name: "搬砖也要吃瓜",
    source: "评 · 道歉声明被扒旧账",
    text: "声明看完了，感觉避重就轻得有点明显，评论区已经从公关聊到法律再聊到人生哲理了。",
    likes: "点赞 3.1k",
    hot: false,
  },
  {
    name: "显微镜本人",
    source: "评 · 同框照引热议",
    text: "放大看了一晚上，细节真的多，不过还是提醒大家理智一点，别被带了节奏。",
    likes: "点赞 2.4k",
    hot: false,
  },
  {
    name: "理性吃瓜一号位",
    source: "评 · 素人自曝聊天记录",
    text: "聊天记录只能代表一方视角，先别站队，等另一边的回应出来再聊也不迟。",
    likes: "点赞 1.8k",
    hot: false,
  },
];

export const tags = [
  { label: "直播现场", heat: 92 },
  { label: "品牌翻车", heat: 86 },
  { label: "CP 同框", heat: 80 },
  { label: "职场热议", heat: 74 },
  { label: "素人投稿", heat: 69 },
  { label: "影视剧情", heat: 63 },
  { label: "综艺名场面", heat: 58 },
  { label: "当事人回应", heat: 52 },
  { label: "补档专区", heat: 47 },
  { label: "微博热搜", heat: 41 },
  { label: "新闻反转", heat: 36 },
  { label: "热评精选", heat: 30 },
];

export const tools = [
  {
    icon: "ri-smartphone-line",
    title: "移动客户端",
    desc: "Android / iOS 双端可用，消息实时推送，吃瓜不错过第一现场。",
    tag: "下载 App",
    accent: true,
  },
  {
    icon: "ri-window-line",
    title: "浏览器插件",
    desc: "网页版一键安装，热点高亮与来源标记，让帖子读起来更清爽。",
    tag: "安装插件",
    accent: false,
  },
  {
    icon: "ri-sound-module-line",
    title: "桌面小组件",
    desc: "把实时热榜钉在桌面，上班摸鱼也能偷偷瞟一眼今日话题。",
    tag: "获取组件",
    accent: false,
  },
  {
    icon: "ri-mail-send-line",
    title: "话题订阅",
    desc: "订阅你关心的分区与关键词，新帖与神评更新第一时间送到邮箱。",
    tag: "去订阅",
    accent: false,
  },
];